import { render, staticRenderFns } from "./ParentTeacher.vue?vue&type=template&id=40258d93"
import script from "./ParentTeacher.vue?vue&type=script&lang=js"
export * from "./ParentTeacher.vue?vue&type=script&lang=js"
import style0 from "./ParentTeacher.vue?vue&type=style&index=0&id=40258d93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports